export const PosQuantity = {
    1: '1',
    2: '2',
    3: '3',
    4: '4 +'
}